import React from 'react';

import {
  Webform,
} from '@uncinc/react-drupal-core';
import { WysiwygField } from '../../../components';

import './style.scss';

const WebformBlock = ({ entity, containerless }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');

  return (
    <div className="WebformBlock">
      <div className="WebformBlock__text__wrapper">
        <h3 className="WebformBlock__title">{title}</h3>
        {body && (
          <WysiwygField
            property="schema:text"
            className="WebformBlock__body"
            html={body}
          />
        )}
      </div>
      <div className="WebformBlock__webform__wrapper">
        <Webform id="newsletter_signup" />
      </div>
    </div>
  );
};

export default WebformBlock;
